module.exports = __webpack_public_path__ + "img/opened.12bd0214.png";